export default {
  titleStyles: {
    fontSize: '17px',
    padding: '15px 20px 15px',
    lineHeight: '10px',
    borderBottom: '1px solid #dfdfdf',
  },

  actionsStyles: {
    borderTop: '1px solid #dfdfdf',
  },

  bodyStyles: {
    padding: '24px 24px 24px',
  },

  customContentStyles: {
    width: '30%',
  },
}
